import { groupBy } from './KRIDataGrouping'
import moment from 'moment'
import setting from '../../config/setting'

// A helper function to extract database data into tables
// input: data:             database data, should be a json format
//        header:           the header of table
//        dataBaseHeader:   corresponding database header
// return: data for display tables
let KRIAlertChartDataFormationMonthly = function(reportingData, alert, threshold) {
    const displayMonths = 8
    let dataset = []
    // group monitoring data by risks
    let temppdata = groupBy(reportingData, 'risk_name')
    for (let keys in temppdata) {
        let tempppdata = groupBy(temppdata[keys], 'kri_id')
        for (let keys in tempppdata) { 
            dataset.push(tempppdata[keys])
        }
    }

    let chartData = []
    // format chart data
    for (let keys in dataset) {
        dataset[keys] = (dataset[keys]).sort((a,b)=>a.period>b.period?1:a.period<b.period?-1:0)
        let data = {}
        let datasetitem = {}
        let labels = []
        let chartdata = []
        let barColor = []
        // iterate through all element in the arrays 
        for (let item in dataset[keys]) {
            let data = dataset[keys][item]
            labels.push(moment(data.period).format('MMM'))
            chartdata.push(data.data)

            let tresholdKey = data.risk_name.split(' ')[0].slice(0,-1) + data.kri_id.split(' ').join('')
            let lowerB = 0
            let highB = 0
            if (threshold != null) {
                lowerB = (threshold.lowkrithreshold)[tresholdKey]
                highB = (threshold.highkrithreshold)[tresholdKey]
            }
            //console.log(tresholdKey)
            //console.log(lowkrithreshold[tresholdKey] + '  '  + data.risk_name)

            barColor.push(dataset[keys][item].data < lowerB ? setting.COLOR.GREEN :
                dataset[keys][item].data < highB ?  setting.COLOR.AMBER : setting.COLOR.RED)
        }
        datasetitem['borderWidth'] = 0
        datasetitem['backgroundColor'] = barColor.slice(-displayMonths)
        datasetitem['data'] = chartdata.slice(-displayMonths)

        let chart = {}
        chart['labels'] = labels.slice(-displayMonths)
        chart['datasets'] = [datasetitem]
        chart['risk_name'] = dataset[keys][0].risk_name
        chart['kri_id'] = dataset[keys][0].kri_id
        chart['description'] = dataset[keys][0].description

        chartData.push(chart)
    }

    for (let dataKeys in chartData) {
        for (let alertKeys in alert) {
            if (chartData[dataKeys].description.includes('Monthly')) {
                if (chartData[dataKeys].risk_name == alert[alertKeys].risk_name) {
                    if (chartData[dataKeys].kri_id == alert[alertKeys].kri_id) {
                        alert[alertKeys].data = chartData[dataKeys]
                    }
                }
            }
        }
    }

    let returndata = alert

    return returndata
}

let KRIAlertChartDataFormationfloodingOverview = function(reportingData, threshold) {
    // const displayMonths = 8
    let dataset = []
    // console.log(reportingData)
    // console.log(alert)
    // console.log(threshold)

    // group monitoring data by risks
    let temppdata = groupBy(reportingData, 'risk_name')
    for (let keys in temppdata) {
        if (temppdata[keys][0].risk_name == 'R1: Adverse External Events Risk (Flooding)') {
            let tempppdata = groupBy(temppdata[keys], 'kri_id')
            for (let keys in tempppdata) {
                dataset.push(tempppdata[keys])
            }
        }
    }



    let chartData = []

    dataset = groupBy(dataset[0], 'period')

    if (dataset == null) {
        return
    }

    // format chart data
    let datasetitem = { data: [], backgroundColor: [] }
    let labels = []
    let risk_name = ''
    let kri_id = ''

    let key = Object.keys(dataset)
    key = key.sort().slice(-7)

    for (let i = 0; i < key.length; i++) {
        let keys = key[i]
        labels.push(moment(keys).format('MMM-DD'))
        // iterate through all element in the arrays 
        let number_station_exceeding_treshold=0
        for (let item in dataset[keys]) {
            let data = dataset[keys][item]
            risk_name = data.risk_name
            kri_id = data.kri_id



            let tresholdKey = data.risk_name.split(' ')[0].slice(0,-1) + data.kri_id.split(' ').join('')
            let lowerB = (threshold.lowkrithreshold)[tresholdKey] != null ? (threshold.lowkrithreshold)[tresholdKey] : 0
            let highB = (threshold.highkrithreshold)[tresholdKey] != null ? (threshold.highkrithreshold)[tresholdKey] : 0
            // console.log(highB)
            //console.log(lowkrithreshold[tresholdKey] + '  '  + data.risk_name)

            if (data.data > highB) {
                number_station_exceeding_treshold++
            }

        }

        datasetitem['data'].push(number_station_exceeding_treshold)
        datasetitem['backgroundColor'].push(setting.COLOR.RED)
        datasetitem['borderWidth'] = 0

    }

    let chart = {}
    chart['labels'] = labels
    chart['datasets'] = [datasetitem]
    chart['risk_name'] = risk_name
    chart['kri_id'] = kri_id
    chart['description'] = 'forecast number of station will have flooding in following week'
    let returndata = chart

    return returndata
}



let KRIAlertChartDataFormationfloodingDetail = function(reportingData, threshold, date) {
    let dataset = []

    const displayMonths = 8
    // group monitoring data by risks
    let temppdata = groupBy(reportingData, 'risk_name')
    for (let keys in temppdata) {
        console.log(temppdata[keys])
        if (temppdata[keys][0].risk_name == 'R1: Adverse External Events Risk (Flooding)') {
            let tempppdata = groupBy(temppdata[keys], 'kri_id')
            for (let keys in tempppdata) {
                dataset.push(tempppdata[keys])
            }
        }
    }

    dataset = groupBy(dataset[0], 'description')
    // format chart data
    let chart = { datasets: [] }


    // extract the 1st array to find the clicked the index
    let timeSeriesArray = dataset[Object.keys(dataset)[0]]
    let selectedIndex = 0
    timeSeriesArray.sort((a, b) => moment(a.period) > moment(b.period) ? 1 : -1 )
    timeSeriesArray.map((item) => {
        //  iterate array to find which element has the period as selected date
        if (moment(item.period).format('MMM-DD') == date) {
            console.log(date, item.period);
            // if match, set the selectedIndex to that index
            selectedIndex = timeSeriesArray.findIndex( arrayitem => arrayitem==item )
        }
    })
    console.log(timeSeriesArray, selectedIndex)
    console.log(dataset)

    for (let keys in dataset) {
        let datasetitem = {}
        let labels = []
        let chartdata = []
        // iterate through all element in the arrays 
        for (let item in dataset[keys]) {
            let data = dataset[keys][item]
            labels.push(moment(data.period).format('MMM-DD'))
            chartdata.push(data.data)

            let tresholdKey = data.risk_name.split(' ')[0].slice(0,-1) + data.kri_id.split(' ').join('')
            let lowerB = 0
            let highB = 0
            if (threshold != null) {
                lowerB = (threshold.lowkrithreshold)[tresholdKey]
                highB = (threshold.highkrithreshold)[tresholdKey]
            }
            //console.log(tresholdKey)
            //console.log(lowkrithreshold[tresholdKey] + '  '  + data.risk_name)
        }
        // console.log(chartdata)
        // compose data only if the station at clicked date excess the threshold
        if (chartdata[selectedIndex] > 10) {
            let station_code = Number(keys.split(' S')[1].split('.')[0])
            //console.log(station_code/200.0)
            let random_color = hslToRgb(1 / (station_code%53), 1, 0.5)

            datasetitem['borderWidth'] = 2
            datasetitem['fill']= false,
            datasetitem['lineTension']= 0.1,
            datasetitem['data'] = chartdata.slice(-displayMonths)
            datasetitem['label'] = keys
            datasetitem['borderColor'] = 'rgba(' + random_color +',1)'
            datasetitem['backgroundColor'] = 'rgba(' + random_color +',1)'
            datasetitem['borderCapStyle'] = 'butt'
            datasetitem['borderDash'] = []
            datasetitem['borderDashOffset'] = 0.0
            datasetitem['borderJoinStyle'] = 'miter'
            datasetitem['hoverBorderWidth'] = 2
        }

        
        chart['labels'] = labels.slice(-displayMonths)
        if (datasetitem.data != null) {
            chart['datasets'].push(datasetitem)
        }
        
        chart['risk_name'] = dataset[keys][0].risk_name
        chart['kri_id'] = dataset[keys][0].kri_id
        chart['description'] = dataset[keys][0].description
    }
    console.log(chart)
    let returndata = chart

    return returndata
}


let KRIAlertChartDataFormationRainfallSourceDetail = function (reportingData, label) {
    
    const displayMonths = 8

    let chart = { datasets: [] }

    let datasetitem = {}
    let random_color_R = 0 
    let random_color_G = 0 
    let random_color_B = 0

    datasetitem['borderWidth'] = 2
    datasetitem['fill'] = false,
    datasetitem['lineTension'] = 0.1,
    datasetitem['data'] = reportingData
    datasetitem['label'] = "rainfall level"
    datasetitem['borderColor'] = 'rgba(' + random_color_R + ',' + random_color_G + ',' + random_color_B + ',1)'
    datasetitem['backgroundColor'] = 'rgba(' + random_color_R + ',' + random_color_G + ',' + random_color_B + ',1)'
    datasetitem['borderCapStyle'] = 'butt'
    datasetitem['borderDash'] = []
    datasetitem['borderDashOffset'] = 0.0
    datasetitem['borderJoinStyle'] = 'miter'
    datasetitem['hoverBorderWidth'] = 2


    chart['labels'] = label.map((time) => { console.log(time); return moment(time).format("hh:mm") })
    if (datasetitem.data != null) {
        chart['datasets'].push(datasetitem)

        chart['risk_name'] = 'R1: Adverse External Events Risk (Flooding)'
        chart['kri_id'] = 'K1'
        chart['description'] = 'Data source for flooding prediction'
    }
    console.log(chart)
    let returndata = chart

    return returndata
}


/**
 * Converts an HSL color value to RGB. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes h, s, and l are contained in the set [0, 1] and
 * returns r, g, and b in the set [0, 255].
 *
 * @param   {number}  h       The hue
 * @param   {number}  s       The saturation
 * @param   {number}  l       The lightness
 * @return  {Array}           The RGB representation
 */
function hslToRgb(h, s, l) {
    var r, g, b;

    if (s == 0) {
        r = g = b = l; // achromatic
    } else {
        var hue2rgb = function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 1 / 2) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }

        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }

    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}


export { KRIAlertChartDataFormationMonthly, KRIAlertChartDataFormationfloodingOverview, KRIAlertChartDataFormationfloodingDetail, KRIAlertChartDataFormationRainfallSourceDetail }





// WEBPACK FOOTER //
// ./src/components/SharedComponents/KRIAlertChartDataFormation.js